import React from 'react';
import ReactDOM from 'react-dom/client';
// I token dell'interfaccia: unica dichiarazione di :root del progetto.
// Va prima di ogni altro css, altrimenti le variabili non esistono ancora.
import { caricaSkin } from './skin';
import Cancello from './components/SitoNonDisponibile';
import './styles/tokens.css';
// Il lampeggio soft della riproposta: una classe sola per i tre posti.
import './styles/lampeggio.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {avviaAccesso} from './avvio';
import {precarica} from './services/casinoApi';
import {sezioniAccese} from './moduli/leggi';
import './i18n';
import {Provider} from "react-redux";
import store from './store';
// Importa error logger
import './utils/errorLogger';
import i18next from 'i18next';

// Error Handler Globale per catturare tutti gli errori
window.addEventListener('error', (event) => {
    console.error('🚨 ERRORE GLOBALE:', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error,
        stack: event.error?.stack,
        timestamp: new Date().toISOString()
    });
    
    // Log dettagliato per debugging
    console.group('🔍 DETTAGLI ERRORE');
    console.error('Messaggio:', event.message);
    console.error('File:', event.filename);
    console.error('Riga:', event.lineno);
    console.error('Colonna:', event.colno);
    console.error('Stack:', event.error?.stack);
    console.error('Window.env:', window.env);
    console.error('REACT_APP_API_URL:', window.env?.REACT_APP_API_URL);
    console.groupEnd();
});

// Cattura errori non gestiti nelle Promise
window.addEventListener('unhandledrejection', (event) => {
    console.error('🚨 PROMISE REJECTED:', {
        reason: event.reason,
        promise: event.promise,
        stack: event.reason?.stack,
        timestamp: new Date().toISOString()
    });
    
    console.group('🔍 DETTAGLI PROMISE REJECTION');
    console.error('Reason:', event.reason);
    console.error('Stack:', event.reason?.stack);
    console.error('Window.env:', window.env);
    console.groupEnd();
});

// Verifica che window.env sia caricato
if (typeof window !== 'undefined') {
    // Attendi che il DOM sia pronto
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            checkEnvConfig();
        });
    } else {
        checkEnvConfig();
    }
}

function checkEnvConfig() {
    if (!window.env) {
        console.error('⚠️ ATTENZIONE: window.env non è definito!');
        console.error('Verifica che /env-config.js sia caricato correttamente');
        
        // Crea un fallback
        window.env = {
            REACT_APP_API_URL: 'http://localhost:9001',
            REACT_APP_BACKOFFICE_API_URL: 'http://localhost:8087',
            REACT_APP_API_VERSION: 'v1',
            REACT_APP_API_TENANT: 1,
            REACT_APP_SPORT_FEED_URL: 'http://localhost:8087',
            REACT_APP_USE_FREE_SPORT_API: false
        };
        console.warn('⚠️ Usando configurazione fallback:', window.env);
    } else {
        console.log('✅ window.env caricato correttamente:', window.env);
    }
    console.log('✅ Aeterium Frontend v2.0 - Lista Utenti, Giroconto, Report attivi');
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Error Boundary per React
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('🚨 REACT ERROR BOUNDARY:', {
            error: error,
            errorInfo: errorInfo,
            componentStack: errorInfo.componentStack,
            timestamp: new Date().toISOString()
        });
        
        console.group('🔍 DETTAGLI REACT ERROR');
        console.error('Error:', error);
        console.error('Error Info:', errorInfo);
        console.error('Component Stack:', errorInfo.componentStack);
        console.error('Window.env:', window.env);
        console.groupEnd();
        
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    padding: '20px',
                    margin: '20px',
                    border: '2px solid red',
                    borderRadius: '5px',
                    backgroundColor: '#ffe6e6'
                }}>
                    <h2>{i18next.t('⚠️ Errore nell\'applicazione')}</h2>
                    <details style={{ whiteSpace: 'pre-wrap' }}>
                        <summary>{i18next.t('Dettagli errore (clicca per espandere)')}</summary>
                        <p><strong>{i18next.t('Errore:')}</strong> {this.state.error && this.state.error.toString()}</p>
                        <p><strong>{i18next.t('Stack:')}</strong></p>
                        <pre>{this.state.errorInfo?.componentStack}</pre>
                        <p><strong>{i18next.t('Window.env:')}</strong></p>
                        <pre>{JSON.stringify(window.env, null, 2)}</pre>
                    </details>
                    <button onClick={() => window.location.reload()}>
                        {i18next.t('Ricarica pagina')}
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

/* La skin prima del primo disegno: chiedere il marchio dopo significa
   mostrare per un istante quello sbagliato, o nessuno. L'attesa è limitata
   dentro caricaSkin, quindi se il servizio è lento il sito parte comunque. */
/* Mentre si aspetta la skin si controlla gia' l'accesso (index.js non aspetta
   piu' App per farlo). I giochi partono appena si sa quali sezioni sono
   accese: con la skin dell'ultima volta e' subito. */
avviaAccesso();
const skinPronta = caricaSkin();
skinPronta.then(() => {
    const accese = sezioniAccese().map((s) => s.chiave);
    precarica(['casino', 'liveCasino'].filter((k) => accese.includes(k)));
}, () => {});
skinPronta.finally(() => root.render(
    <ErrorBoundary>
        <Provider store={store}>
            {/* StrictMode disabilitato temporaneamente per evitare doppi rendering con Chart.js */}
            {/* Senza una skin accesa per questo dominio il sito resta spento. */}
            <Cancello><App/></Cancello>
        </Provider>
    </ErrorBoundary>
));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
